exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.pricing-details[data-v-4d634c4c] {\n  border-left: 1px solid #DBDFE2;\n  border-right: 1px solid #DBDFE2;\n}\n.totals[data-v-4d634c4c] {\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n.totals .table[data-v-4d634c4c] {\n    width: 86%;\n    margin: 0 7%;\n    background: transparent;\n}\n.totals .table td[data-v-4d634c4c] {\n      color: #fff;\n      vertical-align: middle;\n      padding: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-4d634c4c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/summary/SummaryTotals.vue
// module id = 2822
// module chunks = 0